// Please note this a depricated modal. Use Dialog for new functionality
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import styled, { css } from 'styled-components';


const ALERT = 'ALERT';
const INFO = 'INFO';

const propTypes = {
  appearance: PropTypes.oneOf([ALERT, INFO]).isRequired,
};

const StyledModal = styled(Modal)`
  position: relative;
  overflow: auto;
  outline: none;
  margin: auto;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.5);
  border-radius: 8px;
  padding: ${props => props.theme.space.single};

  ${props => props.appearance === ALERT && css`
    width: 340px;
  `};

  ${props => props.appearance === INFO && css`
    width: 640px;
  `};
`;

StyledModal.propTypes = propTypes;

StyledModal.ALERT = ALERT;
StyledModal.INFO = INFO;

export default StyledModal;
